import { OrdersFilterOptions } from "@types";

export const orderStatusColor = {
    [OrdersFilterOptions.paid]: '#17A700',
    [OrdersFilterOptions.unpaid]: '#7C7A81',
    [OrdersFilterOptions.part_paid]: '#FFFFFF',
    [OrdersFilterOptions.all]: '#FFFFFF',
  };

